import { Stack, type SxProps } from "@biom3/react";
import type { ReactNode } from "react";

export const TranslucentContainer = ({
  children,
  sx = {},
}: { children: ReactNode; sx?: SxProps }) => {
  return (
    <Stack
      sx={{
        background: "base.color.translucent.inverse.800",
        borderRadius: "base.borderRadius.x12",
        backdropFilter: {
          default: "blur(8px)",
          medium: "base.frost.100",
        },
        p: [
          "base.spacing.x6",
          "base.spacing.x6",
          "base.spacing.x6",
          "base.spacing.x12",
        ],
        position: "relative",
        overflow: "hidden",
        mb: "base.spacing.x6",
        mx: {
          default: "-24px",
          medium: "inherit",
        },
        ...sx,
      }}
      direction="column"
    >
      {children}
    </Stack>
  );
};
